import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { range } from 'lodash-es';
import { useContext } from './context.jsx';

export default function YearSelector(props) {
  const { sx } = props;
  const pastYieldYears = range(2010, new Date().getFullYear() + 1);
  const { year, setYear } = useContext();

  return (
    <FormControl data-testid="year-selector" sx={{ ...sx }}>
      <Select
        sx={{ maxHeight: 36.5, boxShadow: 1 }}
        labelId="year-label"
        id="year"
        data-testid="yield-years"
        value={year}
        onChange={(event) => setYear(event.target.value)}
        variant="outlined"
      >
        {pastYieldYears.map((y) => (
          <MenuItem key={y} value={y}>
            {y}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
